// Автогенерировано из оригинала hay.agency/cases — полный список проектов.
import type { PortfolioItem } from "./cases";
import vidArchidica from "../assets/video/archidica.mp4.asset.json";
import vidCvmarket from "../assets/video/cvmarket.mp4.asset.json";
import vidEsg from "../assets/video/esg.mp4.asset.json";
import vidVosart from "../assets/video/vosart.mp4.asset.json";
import vidGbcvet from "../assets/video/gbcvet.mp4.asset.json";
import vidQuantum from "../assets/video/quantum.mp4.asset.json";
import vidSatoshi from "../assets/video/satoshifriends.mp4.asset.json";
import vidStyllight from "../assets/video/styllight.mp4.asset.json";

/** Кейс с внутренней страницей разбора */
export const artlinemCase: PortfolioItem = {
  title: "Artlinem.ru",
  subtitle: "Производство вентилируемых заборов",
  href: "https://artlinem.ru/",
  caseUrl: "/cases/artline",
  image: "/cases/artline/artline-case-cover-900.webp",
};

/** Кейс с внутренней страницей разбора */
export const archidicaCase: PortfolioItem = {
  title: "Archidica.com",
  subtitle: "Архитектурное бюро",
  href: "https://archidica.com/",
  caseUrl: "/cases/archidica",
  image: "/cases/archidica/archidica-card-900.webp",
  video: vidArchidica.url,
};

/** Кейс с внутренней страницей разбора */
export const esgCase: PortfolioItem = {
  title: "Esg-moscow.ru",
  subtitle: "Строительство домов и коммерческих объектов",
  href: "https://esg-moscow.ru/",
  caseUrl: "/cases/esg",
  image: "/cases/esg/esg-card-900.webp",
  video: vidEsg.url,
};

/** Кейс с внутренней страницей разбора */
export const gbcvetCase: PortfolioItem = {
  title: "Gbcvet.ru",
  subtitle: "Сеть цветочных магазинов",
  href: "https://gbcvet.ru/",
  caseUrl: "/cases/gbcvet",
  image: "/cases/gbcvet/gbcvet-card-900.webp",
  video: vidGbcvet.url,
};

/** Кейс с внутренней страницей разбора */
export const cvmarketCase: PortfolioItem = {
  title: "Cvmarket.ru",
  subtitle: "Интернет-магазин цветов",
  href: "https://cvmarket.ru/",
  caseUrl: "/cases/cvmarket",
  image: "/cases/cvmarket/cvmarket-card-900.webp",
  video: vidCvmarket.url,
};

/** Кейс с внутренней страницей разбора */
export const systemLogisticCase: PortfolioItem = {
  title: "System logistic.ru",
  subtitle: "Логистические услуги",
  href: "https://system-logistic.ru/",
  caseUrl: "/cases/system-logistic",
  image: "/media/tilda-ss.webp",
};

/** Кейс с внутренней страницей разбора */
export const pokrovskieBaniCase: PortfolioItem = {
  title: "Pokrovskie-bani.ru",
  subtitle: "Банный комплекс",
  href: "https://pokrovskie-bani.ru/",
  caseUrl: "/cases/pokrovskie-bani",
  image: "/media/tilda-pb.webp",
};

export const allCases: PortfolioItem[] = [
  gbcvetCase,
  archidicaCase,
  {
    title: "Quantum-clinic.ru",
    subtitle: "Сеть косметологических клиник",
    href: "https://quantum-clinic.ru/",
    caseUrl: "/cases/quantum-clinic",
    image: "/media/tild3761-6330-4461-b735-316264386131-qc-jpg.webp",
    video: vidQuantum.url,
  },
  {
    title: "Quantum-shop.ru",
    subtitle: "Товары для красоты и ухода",
    href: "https://quantum-shop.ru/",
    caseUrl: "/cases/quantum-shop",
    image: "/media/tild3062-3835-4934-b565-613333343734-qs-jpg.webp",
  },
  systemLogisticCase,
  cvmarketCase,
  esgCase,
  {
    title: "Godsforge.ru",
    subtitle: "Ювелирные изделия",
    href: "https://godsforge.ru/",
    caseUrl: "/cases/godsforge",
    image: "/media/tild6130-3339-4338-b563-363064626239-gf-jpg.webp",
  },
  pokrovskieBaniCase,
  {
    title: "Satoshifriends.com",
    subtitle: "Криптовалютное сообщество",
    href: "https://satoshifriends.com/",
    caseUrl: "/cases/satoshi-friends",
    image: "/media/tild3235-6561-4862-b037-366633636338-sf-jpg.webp",
    video: vidSatoshi.url,
  },
  {
    title: "Satoshi.ru",
    subtitle: "Криптовалютное сообщество",
    href: "https://satoshi.ru/",
    caseUrl: "/cases/satoshi-news",
    image: "/media/tild3466-3332-4630-a438-303139616430-satoshi-jpg.webp",
  },
  {
    title: "Lombard-l1.ru",
    subtitle: "Ломбард",
    href: "https://lombard-l1.ru/",
    caseUrl: "/cases/lombard-l1",
    image: "/media/tild3162-3934-4663-b239-326331333734-l1-jpg.webp",
  },
  artlinemCase,
  {
    title: "Thesensuscode.ru",
    subtitle: "Уходовая косметика для лица",
    href: "https://thesensuscode.ru/",
    caseUrl: "/cases/the-sensus-code",
    image: "/media/tild6237-6361-4465-b437-393934356331-thesensuscoderu-jpg.webp",
  },
  {
    title: "Styllight.ru",
    subtitle: "Стильный свет",
    href: "https://styllight.ru/",
    caseUrl: "/cases/styllight",
    image: "/media/tild6462-3266-4134-b362-643736306333-sl-jpg.webp",
    video: vidStyllight.url,
  },
  {
    title: "Reportage.gallery",
    subtitle: "Галерея авторской тиражной фотографии",
    href: "https://reportage.gallery/",
    caseUrl: "/cases/reportage",
    image: "/media/tild3038-6230-4838-b030-373738346634-rg-jpg.webp",
  },
  {
    title: "Latmosfera.ru",
    subtitle: "Дизайн и архитектурное проектирование",
    href: "https://latmosfera.ru/",
    caseUrl: "/cases/latmosfera",
    image: "/media/tild3866-3436-4332-b064-623132346664-latmosfera-jpg.webp",
  },
  {
    title: "Restet.ru",
    subtitle: "Биомолекулярная уходовая косметика",
    href: "https://restet.ru/",
    caseUrl: "/cases/restet",
    image: "/media/tild3138-3131-4339-a161-386133306665-restet-jpg.webp",
  },
  {
    title: "Bessarabca.shop",
    subtitle: "Фермерский базар с доставкой продуктов и еды",
    href: "https://bessarabca.shop",
    caseUrl: "/cases/bessarabca",
    image: "/media/tild6233-6231-4638-a539-376366336465-bs-jpg.webp",
  },
  {
    title: "Greymy.ru",
    subtitle: "Товары для красоты и ухода",
    href: "https://greymy.ru/",
    caseUrl: "/cases/greymy",
    image: "/media/tild3631-6562-4333-a665-376635643738-greymyru-jpg.webp",
  },
  {
    title: "Timebit.ru",
    subtitle: "Магазин часов",
    href: "https://timebit.ru/",
    caseUrl: "/cases/timebit",
    image: "/media/tild6132-6339-4639-b836-643233396137-tb-jpg.webp",
  },
  {
    title: "Vosart.com",
    subtitle: "Дизайнерская мебель",
    href: "https://vosart.com/",
    caseUrl: "/cases/vosart",
    image: "/media/tild3437-3565-4930-b934-633136323166-va-jpg.webp",
    video: vidVosart.url,
  },
  {
    title: "Byrain.ru",
    subtitle: "Будущее косметологии",
    href: "https://byrain.ru/",
    image: "/media/tild3533-3738-4135-a562-663536336564-byrainru-jpg.webp",
  },
  {
    title: "Wineshope.ru",
    subtitle: "Магазин вина",
    href: "http://wineshope.ru/",
    caseUrl: "/cases/wineshope",
    image: "/media/tild3266-6163-4130-b032-386436333137-wineshop-jpg.webp",
  },
  {
    title: "Sima.today",
    subtitle: "Оборудование для переработки мяса",
    href: "https://sima.today/",
    caseUrl: "/cases/sima",
    image: "/media/tild3230-3635-4238-b430-363233386537-st-jpg.webp",
  },
  {
    title: "Kukusiki.ru",
    subtitle: "Снеки и кондитерская продукция",
    href: "https://kukusiki.ru/",
    caseUrl: "/cases/kukusiki",
    image: "/media/tild3137-3261-4439-a136-613862333061-kukusiki-jpg.webp",
  },
  {
    title: "Kalachevo.com",
    subtitle: "Органические продукты",
    href: "https://kalachevo.com/",
    caseUrl: "/cases/kalachevo",
    image: "/media/tild3562-6331-4137-a465-613734343566-ka-jpg.webp",
  },
  {
    title: "7-lombard.ru",
    subtitle: "Ломбард",
    href: "https://7-lombard.ru/",
    caseUrl: "/cases/7-lombard",
    image: "/media/tild3839-3535-4661-b864-386563313566-7l-jpg.webp",
  },
  {
    title: "PetsRoom",
    subtitle: "Зоотовары",
    href: "https://petsroom.com/",
    caseUrl: "/cases/petsroom",
    image: "/media/tild6230-3262-4333-b762-363939316262-petroo-jpg.webp",
  },
  {
    title: "Levrana",
    subtitle: "Федеральный бренд косметики",
    href: "https://levrana.ru/",
    caseUrl: "/cases/levrana",
    image: "/media/tild3765-6130-4039-b433-303064616266-lvr-jpeg.webp",
  },
  {
    title: "Aleart-design.ru",
    subtitle: "Студия интерьеров и архитектуры",
    href: "https://aleart-design.ru/",
    caseUrl: "/cases/aleart-design",
    image: "/media/tild3038-6561-4261-a330-323934303562-aleart-d-jpg.webp",
  },
  {
    title: "Apkros.ru",
    subtitle: "Арктический Перевалочный Комплекс",
    href: "https://apkros.ru/",
    caseUrl: "/cases/apkros",
    image: "/media/tild3061-6631-4463-b438-323565663265-apkros-jpg.webp",
  },
  {
    title: "Ko-plus.ru",
    subtitle: "Противопожарные работы",
    href: "https://ko-plus.ru/",
    caseUrl: "/cases/ko-plus",
    image: "/media/tild3039-6362-4539-a332-623035383363-ko-plus-jpg.webp",
  },
  {
    title: "Vilaxii.ru",
    subtitle: "Современная мебель",
    href: "https://vilaxii.ru/",
    caseUrl: "/cases/vilaxii",
    image: "/media/tild3835-3635-4238-b131-373034343131-vilaxii-jpg.webp",
  },
  {
    title: "Sergeylistopad.ru",
    subtitle: "Основатель нового жанра",
    href: "https://sergeylistopad.ru/",
    caseUrl: "/cases/sergey-listopad",
    image: "/media/tild3361-6561-4663-a465-343131623365-magic-jpg.webp",
  },
  {
    title: "Lubim-pech.ru",
    subtitle: "Вкусная выпечка",
    href: "https://lubim-pech.ru/",
    caseUrl: "/cases/lubim-pech",
    image: "/media/tild3035-3237-4331-b139-613732346531-lp-jpg.webp",
  },
];

export const ecomTabCases: PortfolioItem[] = [
  gbcvetCase,
  {
    title: "Quantum-shop.ru",
    subtitle: "Товары для красоты и ухода",
    href: "https://quantum-shop.ru/",
    caseUrl: "/cases/quantum-shop",
    image: "/media/tild3062-3835-4934-b565-613333343734-qs-jpg.webp",
  },
  cvmarketCase,
  {
    title: "Godsforge.ru",
    subtitle: "Ювелирные изделия",
    href: "https://godsforge.ru/",
    caseUrl: "/cases/godsforge",
    image: "/media/tild6130-3339-4338-b563-363064626239-gf-jpg.webp",
  },
  {
    title: "Styllight.ru",
    subtitle: "Стильный свет",
    href: "https://styllight.ru/",
    caseUrl: "/cases/styllight",
    image: "/media/tild6462-3266-4134-b362-643736306333-sl-jpg.webp",
    video: vidStyllight.url,
  },
  {
    title: "Restet.ru",
    subtitle: "Биомолекулярная уходовая косметика",
    href: "https://restet.ru/",
    caseUrl: "/cases/restet",
    image: "/media/tild3138-3131-4339-a161-386133306665-restet-jpg.webp",
  },
  {
    title: "Bessarabca.shop",
    subtitle: "Фермерский базар с доставкой продуктов и еды",
    href: "https://bessarabca.shop",
    caseUrl: "/cases/bessarabca",
    image: "/media/tild6233-6231-4638-a539-376366336465-bs-jpg.webp",
  },
  {
    title: "Greymy.ru",
    subtitle: "Товары для красоты и ухода",
    href: "https://greymy.ru/",
    caseUrl: "/cases/greymy",
    image: "/media/tild3631-6562-4333-a665-376635643738-greymyru-jpg.webp",
  },
  {
    title: "Timebit.ru",
    subtitle: "Магазин часов",
    href: "https://timebit.ru/",
    caseUrl: "/cases/timebit",
    image: "/media/tild6132-6339-4639-b836-643233396137-tb-jpg.webp",
  },
  {
    title: "Vosart.com",
    subtitle: "Дизайнерская мебель",
    href: "https://vosart.com/",
    caseUrl: "/cases/vosart",
    image: "/media/tild3437-3565-4930-b934-633136323166-va-jpg.webp",
    video: vidVosart.url,
  },
  {
    title: "Byrain.ru",
    subtitle: "Будущее косметологии",
    href: "https://byrain.ru/",
    image: "/media/tild3533-3738-4135-a562-663536336564-byrainru-jpg.webp",
  },
  {
    title: "Wineshope.ru",
    subtitle: "Магазин вина",
    href: "http://wineshope.ru/",
    caseUrl: "/cases/wineshope",
    image: "/media/tild3266-6163-4130-b032-386436333137-wineshop-jpg.webp",
  },
  {
    title: "Kukusiki.ru",
    subtitle: "Снеки и кондитерская продукция",
    href: "https://kukusiki.ru/",
    caseUrl: "/cases/kukusiki",
    image: "/media/tild3137-3261-4439-a136-613862333061-kukusiki-jpg.webp",
  },
  {
    title: "Kalachevo.com",
    subtitle: "Органические продукты",
    href: "https://kalachevo.com/",
    caseUrl: "/cases/kalachevo",
    image: "/media/tild3562-6331-4137-a465-613734343566-ka-jpg.webp",
  },
  {
    title: "Lubim-pech.ru",
    subtitle: "Вкусная выпечка",
    href: "https://lubim-pech.ru/",
    caseUrl: "/cases/lubim-pech",
    image: "/media/tild3035-3237-4331-b139-613732346531-lp-jpg.webp",
  },
  {
    title: "PetsRoom",
    subtitle: "Зоотовары",
    href: "https://petsroom.com/",
    caseUrl: "/cases/petsroom",
    image: "/media/tild6230-3262-4333-b762-363939316262-petroo-jpg.webp",
  },
  {
    title: "Levrana",
    subtitle: "Федеральный бренд косметики",
    href: "https://levrana.ru/",
    caseUrl: "/cases/levrana",
    image: "/media/tild3765-6130-4039-b433-303064616266-lvr-jpeg.webp",
  },
];

export const siteTabCases: PortfolioItem[] = [
  archidicaCase,
  {
    title: "Quantum-clinic.ru",
    subtitle: "Сеть косметологических клиник",
    href: "https://quantum-clinic.ru/",
    caseUrl: "/cases/quantum-clinic",
    image: "/media/tild3761-6330-4461-b735-316264386131-qc-jpg.webp",
    video: vidQuantum.url,
  },
  systemLogisticCase,
  esgCase,
  {
    title: "Godsforge.ru",
    subtitle: "Ювелирные изделия",
    href: "https://godsforge.ru/",
    caseUrl: "/cases/godsforge",
    image: "/media/tild6130-3339-4338-b563-363064626239-gf-jpg.webp",
  },
  pokrovskieBaniCase,
  artlinemCase,
  {
    title: "Satoshifriends.com",
    subtitle: "Криптовалютное сообщество",
    href: "https://satoshifriends.com/",
    caseUrl: "/cases/satoshi-friends",
    image: "/media/tild3235-6561-4862-b037-366633636338-sf-jpg.webp",
    video: vidSatoshi.url,
  },
  {
    title: "Satoshi.ru",
    subtitle: "Криптовалютное сообщество",
    href: "https://satoshi.ru/",
    caseUrl: "/cases/satoshi-news",
    image: "/media/tild3466-3332-4630-a438-303139616430-satoshi-jpg.webp",

  },
  {
    title: "Lombard-l1.ru",
    subtitle: "Ломбард",
    href: "https://lombard-l1.ru/",
    caseUrl: "/cases/lombard-l1",
    image: "/media/tild3162-3934-4663-b239-326331333734-l1-jpg.webp",
  },
  {
    title: "Styllight.ru",
    subtitle: "Стильный свет",
    href: "https://styllight.ru/",
    caseUrl: "/cases/styllight",
    image: "/media/tild6462-3266-4134-b362-643736306333-sl-jpg.webp",
    video: vidStyllight.url,
  },
  {
    title: "Reportage.gallery",
    subtitle: "Галерея авторской тиражной фотографии",
    href: "https://reportage.gallery/",
    caseUrl: "/cases/reportage",
    image: "/media/tild3038-6230-4838-b030-373738346634-rg-jpg.webp",
  },
  {
    title: "Latmosfera.ru",
    subtitle: "Дизайн и архитектурное проектирование",
    href: "https://latmosfera.ru/",
    caseUrl: "/cases/latmosfera",
    image: "/media/tild3866-3436-4332-b064-623132346664-latmosfera-jpg.webp",
  },
  {
    title: "Greymy.ru",
    subtitle: "Товары для красоты и ухода",
    href: "https://greymy.ru/",
    caseUrl: "/cases/greymy",
    image: "/media/tild3631-6562-4333-a665-376635643738-greymyru-jpg.webp",
  },
  {
    title: "Sima.today",
    subtitle: "Оборудование для переработки мяса",
    href: "https://sima.today/",
    caseUrl: "/cases/sima",
    image: "/media/tild3230-3635-4238-b430-363233386537-st-jpg.webp",
  },
  {
    title: "7-lombard.ru",
    subtitle: "Ломбард",
    href: "https://7-lombard.ru/",
    caseUrl: "/cases/7-lombard",
    image: "/media/tild3839-3535-4661-b864-386563313566-7l-jpg.webp",
  },
  {
    title: "Aleart-design.ru",
    subtitle: "Студия интерьеров и архитектуры",
    href: "https://aleart-design.ru/",
    caseUrl: "/cases/aleart-design",
    image: "/media/tild3038-6561-4261-a330-323934303562-aleart-d-jpg.webp",
  },
];

export const landingTabCases: PortfolioItem[] = [
  {
    title: "Satoshifriends.com",
    subtitle: "Криптовалютное сообщество",
    href: "https://satoshifriends.com/",
    caseUrl: "/cases/satoshi-friends",
    image: "/media/tild3235-6561-4862-b037-366633636338-sf-jpg.webp",
    video: vidSatoshi.url,
  },
  {
    title: "Satoshi.ru",
    subtitle: "Криптовалютное сообщество",
    href: "https://satoshi.ru/",
    caseUrl: "/cases/satoshi-news",
    image: "/media/tild3466-3332-4630-a438-303139616430-satoshi-jpg.webp",
  },
  {
    title: "Thesensuscode.ru",
    subtitle: "Уходовая косметика для лица",
    href: "https://thesensuscode.ru/",
    caseUrl: "/cases/the-sensus-code",
    image: "/media/tild6237-6361-4465-b437-393934356331-thesensuscoderu-jpg.webp",
  },
  {
    title: "Apkros.ru",
    subtitle: "Арктический Перевалочный Комплекс",
    href: "https://apkros.ru/",
    caseUrl: "/cases/apkros",
    image: "/media/tild3061-6631-4463-b438-323565663265-apkros-jpg.webp",
  },
  {
    title: "Ko-plus.ru",
    subtitle: "Противопожарные работы",
    href: "https://ko-plus.ru/",
    caseUrl: "/cases/ko-plus",
    image: "/media/tild3039-6362-4539-a332-623035383363-ko-plus-jpg.webp",
  },
  {
    title: "Vilaxii.ru",
    subtitle: "Современная мебель",
    href: "https://vilaxii.ru/",
    caseUrl: "/cases/vilaxii",
    image: "/media/tild3835-3635-4238-b131-373034343131-vilaxii-jpg.webp",
  },
  {
    title: "Sergeylistopad.ru",
    subtitle: "Основатель нового жанра",
    href: "https://sergeylistopad.ru/",
    caseUrl: "/cases/sergey-listopad",
    image: "/media/tild3361-6561-4663-a465-343131623365-magic-jpg.webp",
  },
];
